import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { createOrder, CreateOrderRequestMessage } from '../common/api/clients/one-port.api';

export const useOnePortOrder = () => {
    return useMutation<void, AxiosError<{ reason: string }>, CreateOrderRequestMessage>({
        mutationFn: createOrder,
    });
};
